import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import "./ModalPrivileges.css";

Modal.setAppElement("#root");
const API_BASE = process.env.REACT_APP_API_BASE_URL;


// ─── Catálogo de privilegios disponibles ─────────────────────────────────────
// Agrega aquí nuevas entradas cuando se expandan los privilegios
const PRIVILEGE_FIELDS = [
  { key: "dashboard", label: "Dashboard" },
  { key: "users",     label: "Usuarios"  },
  { key: "devices",   label: "Dispositivos" },
];

const buildInitialPrivileges = () =>
  Object.fromEntries(PRIVILEGE_FIELDS.map(({ key }) => [key, "0"]));

// ─── Componente ──────────────────────────────────────────────────────────────
const ModalPrivileges = ({ isOpen, onRequestClose, privilegesData, userId }) => {
  const [privileges,     setPrivileges]     = useState(buildInitialPrivileges());
  const [processMessage, setProcessMessage] = useState("");
  const [processType,    setProcessType]    = useState("");

  // ── Carga privilegios ───────────────────────────────────────────────────────
  useEffect(() => {
    if (!isOpen) return;

    if (privilegesData) {
      // Vienen desde el padre (AuthContext / userData)
      setPrivileges({
        dashboard: privilegesData.dashboard ? "1" : "0",
        users:     privilegesData.users     ? "1" : "0",
        devices:   privilegesData.devices   ? "1" : "0",
      });
    } else if (userId) {
      // Fetch directo si el padre no los pasó
      fetch(`${API_BASE}/api/getUserPrivileges?id_user=${userId}`)
        .then((res) => res.json())
        .then((data) => {
          if (data.success) {
            setPrivileges({
              dashboard: data.privileges.dashboard ? "1" : "0",
              users:     data.privileges.users     ? "1" : "0",
              devices:   data.privileges.devices   ? "1" : "0",
            });
          } else {
            setProcessMessage(data.message);
            setProcessType("error");
          }
        })
        .catch(() => {
          setProcessMessage("Error al obtener privilegios.");
          setProcessType("error");
        });
    }
  }, [isOpen, privilegesData, userId]);

  // ── Handlers ───────────────────────────────────────────────────────────────
  const handleChange = (e) => {
    const { name, value } = e.target;
    setPrivileges((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = {
      id_user:    userId,
      privileges: {
        dashboard: Number(privileges.dashboard),  // ← número al backend
        users:     Number(privileges.users),
        devices:   Number(privileges.devices),
      },
    };

    fetch(`${API_BASE}/api/updatePrivileges`, {
      method:  "POST",
      headers: { "Content-Type": "application/json" },
      body:    JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then((data) => {
        setProcessType(data.success ? "success" : "error");
        setProcessMessage(data.message);
        setTimeout(() => {
          setProcessMessage("");
          setProcessType("");
          onRequestClose();
        }, 1200);
      })
      .catch(() => {
        setProcessType("error");
        setProcessMessage("Error al actualizar privilegios.");
      });
  };

  // ── Render — filas de 2 ────────────────────────────────────────────────────
  const renderRows = () => {
    const rows = [];
    for (let i = 0; i < PRIVILEGE_FIELDS.length; i += 2) {
      rows.push(PRIVILEGE_FIELDS.slice(i, i + 2));
    }
    return rows.map((row, idx) => (
      <div className="form-row" key={idx}>
        {row.map(({ key, label }) => (
          <div
            key={key}
            className={`form-group privilege-group ${
              privileges[key] === "0" ? "no-access" : "has-access"
            }`}
          >
            <label htmlFor={key}>{label}</label>
            <select
              id={key}
              name={key}
              value={privileges[key]}
              onChange={handleChange}
            >
              <option value="0">Sin acceso</option>
              <option value="1">Acceso</option>
            </select>
          </div>
        ))}
      </div>
    ));
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className="modal-content"
      overlayClassName="modal-overlay"
    >
      {/* Header */}
      <div className="modal-header">
        <h2>Gestionar Privilegios</h2>
        <hr />
      </div>

      {/* Body */}
      <div className="modal-body">
        <form onSubmit={handleSubmit}>
          <div className="privileges-container">{renderRows()}</div>

          <div className="modal-actions">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onRequestClose}
            >
              Cancelar
            </button>
            <button type="submit" className="btn btn-success">
              Actualizar
            </button>
          </div>
        </form>
      </div>

      {/* Mensaje de proceso */}
      {processMessage && (
        <p className={`process-message ${processType}`}>{processMessage}</p>
      )}
    </Modal>
  );
};

export default ModalPrivileges;